// Imports ------------------------------------------------------------------->

import {Service, service, inject} from "./di";
import {ConfigService} from "./ConfigService";
import {LocationService} from "./LocationService";
import {AnalyticsService} from "./AnalyticsService";

// Private Definitions ------------------------------------------------------->

// Public Definitions -------------------------------------------------------->

@service("historyService")
export class HistoryService extends Service {
	@inject config: ConfigService;
	@inject analytics: AnalyticsService;
	@inject location: LocationService;

	_blockItemRender = false;

	doBack() {
		/* Workaround for Safari issues in distribution. It seems like Safari shares part of the
			* `history` object with the parent when Flipp Web is embedded in an iframe. This means that
			* calling `history.back()` actually reloads the page. Instead, what we do here is maintain a
			* single entry in history and save the previous URLs in state. Instead of calling `history.back()`
			* in these cases, simply restore the last URL.
			*/
		if (this.config.PUSHSTATE_SUPPORTED) {
			history.back();
		} else {
			const prev = history.state || [];
			if (prev && prev.length > 0) {
				const url = prev.pop();
				history.replaceState(prev.splice(-1, 1), "", url);
			} else {
				history.replaceState([], "", "/");
			}
		}
	}

	prepareDistState() {
		const params = this.analytics.analyticsParameters;
		const pageLink = window.location.pathname + window.location.search;
		const paramsArr = Object.getOwnPropertyNames(params).map((key) => `${key}=${encodeURIComponent(params[key])}`);
		paramsArr.push(`fsa=${this.location.postalCode}`);
		paramsArr.push(`locale=${this.location.locale}`);
		paramsArr.push(`context=${encodeURIComponent(pageLink)}`);
		if (this.config.CDP_SIMPLE_HEADER) {
			paramsArr.push(`publisher_name=${encodeURIComponent(this.config.CDP_PUBLISHER_NAME)}`);
			paramsArr.push(`website_url=${this.config.CDP_BACK_LINK}`);
		}
		if (document.documentElement.getAttribute("native")) {
			paramsArr.push("exp=native");
		}
		const distUrl = `/dist?${paramsArr.join("&")}`;
		/* Replace the current history state with the /dist URL and all parameters */
		history.pushState({}, "", distUrl);
	}

	get blockItemRender() {
		return this._blockItemRender;
	}

	set blockItemRender(value: boolean) {
		this._blockItemRender = value;
	}
}
